import { createContext, useContext } from 'react'

import { useAutoRelated } from '../../hooks'

import type { RelatedProductsProviderProps, RelatedProductsState } from '../../types'

const RelatedProductsContext = createContext<RelatedProductsState | undefined>(undefined)

/**
 * Thin Provider for related products state
 * Calls useAutoRelated composition hook
 */
export function RelatedProductsProvider({ children, productSku }: RelatedProductsProviderProps) {
  const relatedState = useAutoRelated(productSku)

  return <RelatedProductsContext value={relatedState}>{children}</RelatedProductsContext>
}

export function useRelatedProducts() {
  const context = useContext(RelatedProductsContext)
  if (context === undefined) {
    throw new Error('useRelatedProducts must be used within a RelatedProductsProvider')
  }
  return context
}
